import _ from 'lodash'
import i18n from 'scoreboard/components/i18n'
import currentUser from 'scoreboard/components/user'
import ScorecardReportModel from 'scoreboard/reports/scorecard-report/scorecard-report-model'
import projects from 'scoreboard/projects/projects'

export default ScorecardReportModel.extend({
	defaults: function() {
		const user = _.clone(currentUser.model.attributes)
		user.type = 'user'
		return _.extend(ScorecardReportModel.prototype.defaults(), {
			label: i18n.get('report.ownerUpdaterReport.title'),
			filters: {
				scorecardNodeIds: [{
					values: [],
					linkGroup: 1
				}],
				owners: [{
					values: [],
					operator: 'contains-any',
					linkGroup: 0,
					anyValue: true,
					anyValueLabelCode: 'common.user.anyUserOrGroup'
				}],
				updaters: [{
					values: [],
					operator: 'contains-any',
					linkGroup: 0,
					anyValue: true,
					anyValueLabelCode: 'common.user.anyUserOrGroup'
				}],
				projectIds: [{values:[projects.id]}]
			},
			structure: {
				stacks: [
					this._defaultStackData('label', {sortType: 'tree'}),
					this._defaultStackData('owners'),
					this._defaultStackData('updaters')
				]
			}
		})
	}
})
